import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const nav = useNavigate();

  useEffect(() => {
    if (token) {
      nav(`/signup?token=${token}`, { replace: true });
    } else {
      nav('/signup', { replace: true });
    }
  }, [token, nav]);

  return null;
}
